import { Select, MenuItem } from '@mui/material';
import { useSelector } from 'react-redux';
import { PrivilegeLevels } from '../../shared/constants/PrivilegeLevels';

const AdminCategorySelect = (props) => {
  const { category, handleCategoryChange } = props;

  const user = useSelector((state) => state.user);
  const isAdminPrivilegeProtected = user.userInfo.privilege > PrivilegeLevels.manager.level;
  const contentLogActivated = user.addonControls.contentLogActivated === true;

  if (isAdminPrivilegeProtected) {
    return (
      <Select
        labelId="contact-category"
        id="contact-category-select"
        value={category}
        label="Category"
        onChange={handleCategoryChange}
        size="small"
      >
        <MenuItem value={'Users'}>Users</MenuItem>
        <MenuItem value={'Units'}>Units</MenuItem>
        <MenuItem value={'Departments'}>Departments</MenuItem>
        <MenuItem value={'Campaigns'}>Campaigns</MenuItem>
        {contentLogActivated && <MenuItem value={'Audiences'}>Audiences</MenuItem>}
        <MenuItem value={'Types'}>Types</MenuItem>
        <MenuItem value={'Custom Fields'}>Contacts Custom Fields</MenuItem>
      </Select>
    );
  }

  return (
    <Select
      labelId="contact-category"
      id="contact-category-select"
      value={category}
      label="Category"
      onChange={handleCategoryChange}
      size="small"
    >
      <MenuItem value={'Users'}>Users</MenuItem>
      <MenuItem value={'Units'}>Units</MenuItem>
      <MenuItem value={'Departments'}>Departments</MenuItem>
      <MenuItem value={'Campaigns'}>Campaigns</MenuItem>
      {contentLogActivated && <MenuItem value={'Audiences'}>Audiences</MenuItem>}
      <MenuItem value={'Types'}>Types</MenuItem>
    </Select>
  );
};

export default AdminCategorySelect;
